const isEmptyString = (str) => {
    return str.trim() === '';
};

export default isEmptyString;
